var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.breadcrumbs.length)?_c('ol',{staticClass:"breadcrumb breadcrumb-arrows",attrs:{"aria-label":"breadcrumbs"}},_vm._l((_vm.breadcrumbs),function(item,index){return _c('li',{key:index,staticClass:"breadcrumb-item",class:_vm.isActive(item.name)},[_c('router-link',{attrs:{"to":{name: item.name },"tag":"a"}},[_vm._v(_vm._s(_vm.$t(("" + (item.title)))))])],1)}),0):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-291358a2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumb.vue
// module id = null
// module chunks = 